<template>
  <div>
    <HeroBanner :page="'rules'" />
    <div class="container">
      <h2 class="title">{{ $t('pages.rules.content.equipment.title') }}</h2>
      <div class="tile is-ancestor">
        <RequiredEquipment
          :name="$t('pages.rules.content.equipment.table')"
          :image="'/static/images/table.jpg'"/>
        <RequiredEquipment
          :name="$t('pages.rules.content.equipment.paddle')"
          :image="'/static/images/paddle.jpg'"/>
        <RequiredEquipment
          :name="$t('pages.rules.content.equipment.ball')"
          :image="'/static/images/ball.jpg'"/>
        <RequiredEquipment
          class="gob"
          :name="$t('pages.rules.content.equipment.gob')"
          :image="'/static/images/cup.jpg'"/>
      </div>
      <h2 class="title">{{ $t('pages.rules.content.preparation.title') }}</h2>
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <div class="subtitle">
              {{ $t('pages.rules.content.preparation.above') }}
            </div>
            <div class="is-flex disposition">
              <figure class="image above-view">
                <img src="@/assets/images/above-view.png" :alt="$t('pages.rules.content.preparation.above')">
              </figure>
            </div>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <div class="subtitle">
              {{ $t('pages.rules.content.preparation.side') }}
            </div>
            <div class="is-flex disposition">
              <figure class="image is-flex profil-view">
                <img src="@/assets/images/profil-view.png" :alt="$t('pages.rules.content.preparation.side')">
              </figure>
            </div>
          </article>
        </div>
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">{{ $t('pages.rules.content.goal.title') }}</p>
            <p class="subtitle">{{ $t('pages.rules.content.goal.description') }}</p>
          </article>
        </div>
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">#1</p>
            <p class="subtitle">{{ $t('pages.rules.content.rules.unit') }}</p>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">#2</p>
            <p class="subtitle">{{ $t('pages.rules.content.rules.points.standard.presentation') }}</p>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">#3</p>
            <p class="subtitle">{{ $t('pages.rules.content.rules.points.slide.presentation') }}</p>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">#4</p>
            <p class="subtitle">{{ $t('pages.rules.content.rules.statusquo.presentation') }}</p>
          </article>
        </div>
      </div>

      <div class="tile is-ancestor">
        <div class="tile is-vertical is-9">
          <div class="tile">
            <div class="tile is-parent">
              <article class="tile is-child box">
                <p class="title">#5</p>
                <p class="subtitle">{{ $t('pages.rules.content.rules.preparation.title') }}</p>
                <div class="content">
                  <p>{{ $t('pages.rules.content.rules.preparation.first') }}</p>
                  <p>{{ $t('pages.rules.content.rules.preparation.second') }}</p>
                </div>
              </article>
            </div>
            <div class="tile is-8 is-vertical">
              <div class="tile">
                <div class="tile is-parent">
                  <article class="tile is-child box">
                    <p class="title">#6</p>
                    <p class="subtitle">{{ $t('pages.rules.content.rules.points.standard.effect') }}</p>
                  </article>
                </div>
                <div class="tile is-parent">
                  <article class="tile is-child box">
                    <p class="title">#7</p>
                    <p class="subtitle">{{ $t('pages.rules.content.rules.points.standard.effect') }}</p>
                  </article>
                </div>
              </div>
              <div class="tile is-parent">
                <article class="tile is-child box">
                  <p class="title">#8</p>
                  <p class="subtitle">{{ $t('pages.rules.content.rules.bdg') }}</p>
                </article>
              </div>
            </div>
          </div>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <div class="content">
              <p class="title">#9</p>
              <p class="subtitle">Status-quo</p>
              <div class="content">
                <p>{{ $t('pages.rules.content.rules.statusquo.effect.first') }}</p>
                <p>{{ $t('pages.rules.content.rules.statusquo.effect.second') }}</p>
              </div>
            </div>
          </article>
        </div>
      </div>

      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">#10</p>
            <p class="subtitle">{{ $t('pages.rules.content.rules.services.title') }}</p>
            <div>
              {{ $t('pages.rules.content.rules.services.first') }}
              {{ $t('pages.rules.content.rules.services.second') }}
              {{ $t('pages.rules.content.rules.services.third') }}
            </div>
          </article>
        </div>
      </div>
      <div>
        <h2 class="title">{{ $t('pages.rules.content.rules.gameplay.title') }}</h2>
        <div class="tile is-ancestor">
          <div class="tile is-parent">
            <article class="tile is-child box">
              <div>
                <p>{{ $t('pages.rules.content.rules.gameplay.neverTooLate') }}</p>
              </div>
            </article>
          </div>
        </div>
        <div class="tile is-ancestor">
          <div class="tile is-parent">
            <article class="tile is-child box">
              <div>
                <p>{{ $t('pages.rules.content.rules.gameplay.strategy') }}</p>
              </div>
            </article>
          </div>
        </div>
        <div class="tile is-ancestor">
          <div class="tile is-parent">
            <article class="tile is-child box">
              <div>
                <p>{{ $t('pages.rules.content.rules.gameplay.levels') }}</p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeroBanner from '@/components/HeroBanner'
import RequiredEquipment from '@/components/RequiredEquipment'
export default {
  components: {
    HeroBanner,
    RequiredEquipment
  }
}
</script>

<style scoped>

  .disposition {
    justify-content: center;
  }
  .above-view {
    width: 128px;
  }
  .profil-view {
    width: 256px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PageRules.vue